import useUserData from "./user/useUserData";
import {useMemo} from "react";

export const useMultilingualText = (text) => {
    const {language} = useUserData()
    return useMemo(() => (typeof text === "string" || !Boolean(text)) ? text : text[language], [language, text])
}